import { render } from "./Provider.vue?vue&type=template&id=21cde1d0&scoped=true"
import script from "./Provider.vue?vue&type=script&lang=js"
export * from "./Provider.vue?vue&type=script&lang=js"

import "@/assets/css/layout_provider.css?vue&type=style&index=0&id=21cde1d0&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21cde1d0"]])

export default __exports__